import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import { theme } from './theme';
import { installSourceSystemFetchHeader } from './utils/sourceSystemHeaders';

installSourceSystemFetchHeader();

// Create React Query client with optimized cache strategy
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Increased for long user sessions (was 5 minutes)
      staleTime: 10 * 60 * 1000,       // 10 minutes (longer cache for better UX)
      gcTime: 30 * 60 * 1000,          // 30 minutes (garbage collection time)
      
      refetchOnWindowFocus: false,     // Disabled (too aggressive for dashboard apps)
      refetchOnReconnect: true,        // Enabled (good for connectivity issues)
      refetchOnMount: false,           // Disabled to prevent duplicate calls on mount
      
      retry: 1,                        // Retry once on failure
      retryDelay: 1000,                // 1 second between retries
    },
  },
});

// Global observer for pages-for-site queries
queryClient.getQueryCache().subscribe((event) => {
  if (event?.query?.queryKey[0] === 'pages-for-site') {
    console.log('🔍 [QUERY CACHE] Pages query event:', {
      type: event.type,
      queryKey: event.query.queryKey,
      state: event.query.state.status,
      isFetching: (event.query.state as any).isFetching,
      dataUpdatedAt: new Date(event.query.state.dataUpdatedAt).toLocaleTimeString()
    });
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  </BrowserRouter>
);
